"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.p = void 0;
function p(el) {
    var dir = el.getAttribute('dir');
    if (!dir) {
        el.setAttribute('dir', 'auto');
    }
}
exports.p = p;
//# sourceMappingURL=p.method.js.map